import { HTTP } from '@/http/http-client';
import { mapBodyParams } from '@/utils/mapBodyParams';

const getProfile = ( parentId ) =>
    HTTP.get(`parents/${parentId}`).then(({ data }) => data);

const editProfile = ({ parentId, parentUpdateForm }) =>
    HTTP.put(`parents/${parentId}`, mapBodyParams(parentUpdateForm)).then(({ data }) => data);

const changePassword = ({ parentId, passwordForm }) =>
     HTTP.patch(`parents/${parentId}/password`, passwordForm).then(({ data }) => data);

const changeEmail = ({ parentId, form }) =>
    HTTP.patch(`parents/${parentId}/slug/new-email`, form).then(({ data }) => data);

const getProfileNotificationsStatus = ( parentId ) =>
    HTTP.get(`parents/${parentId}/notifications`).then(({ data }) => data);

const changeEmailOnAddingToWaitListStatus = ({ parentId, status }) =>
    HTTP.patch(`parents/${parentId}/notifications/add-to-waitlist?value=${status}`).then(({ data }) => data);

const changeEmailOnRemovingFromWaitListStatus = ({ parentId, status }) =>
    HTTP.patch(`parents/${parentId}/notifications/remove-from-waitlist?value=${status}`).then(({ data }) => data);

const changeEmailOnScheduleChangeStatus = ({ parentId, status }) =>
    HTTP.patch(`parents/${parentId}/notifications/schedule-change?value=${status}`).then(({ data }) => data);

const changeEmailOnSuccessfulEnrollmentStatus = ({ parentId, status }) =>
    HTTP.patch(`parents/${parentId}/notifications/successful-enrollment?value=${status}`).then(({ data }) => data);

const getAvatar = ( parentId ) =>
    HTTP.get(`parents/${parentId}/profile-image`).then(({ data }) => data);

const uploadAvatar = ({ parentId, file }) => {
    const headers = {'Content-Type': 'multipart/form-data'};
    const formData = new FormData();
    formData.append('image', file);
    return HTTP.patch(`parents/${parentId}/profile-image`, formData, { headers });
};

const removeAvatar = ( parentId ) =>
    HTTP.delete(`parents/${parentId}/profile-image`);

export default {
    getProfile,
    editProfile,
    changePassword,
    changeEmail,
    getProfileNotificationsStatus,
    changeEmailOnAddingToWaitListStatus,
    changeEmailOnRemovingFromWaitListStatus,
    changeEmailOnScheduleChangeStatus,
    changeEmailOnSuccessfulEnrollmentStatus,
    getAvatar,
    uploadAvatar,
    removeAvatar
};


// WEBPACK FOOTER //
// ./src/http/services/profileService.js